import { AuwBaseComponent } from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwStickyHeader extends AuwBaseComponent {
  constructor($el) {
    super($el);
  }

  __PageReady() {
    const navbar = document.getElementsByClassName("header-container");

    if (
      document.body.classList.contains("has-stage") && $(window).width() > 991
    ) {
      if (navbar[0] != null) {
        document.addEventListener("scroll", function () {
          if (window.pageYOffset >= 10) {
            navbar[0].classList.add("sticky");
          } else {
            navbar[0].classList.remove("sticky");
          }
        });

        if (window.pageYOffset >= 10) {
          navbar[0].classList.add("sticky");
        }
      }
    } else if (
      !document.body.classList.contains("has-stage") &&
      !document.body.classList.contains("stage-under-menu") &&
      $(window).width() > 991
    ) {
      if (navbar[0] != null) {
        document.addEventListener("scroll", function () {
          if (window.pageYOffset >= 10) {
            navbar[0].classList.add("sticky");
          } else {
            navbar[0].classList.remove("sticky");
          }
        });
      }
    }
  }
}

if ($(".header-container").length) {
  $.each($(".header-container"), function (i, e) {
    new AuwStickyHeader($(e));
  });
}
